// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__2Mff7","buttons":"PendingPaymentAlert_buttons__3QcyI"};